import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-brand">
            <h3 className="footer-logo">
              <span className="logo-gradient">6 C's</span>
            </h3>
            <p className="footer-tagline">
              The Branded Content Agency At Your Service
            </p>
          </div>

          <div className="footer-links">
            <div className="footer-column">
              <h4>Quick Links</h4>
              <ul>
                <li><a href="#what-we-do">What We Do</a></li>
                <li><a href="#why-partner">Why Partner With Us</a></li>
                <li><a href="#mission">Mission & Vision</a></li>
                <li><a href="#contact">Get In Touch</a></li>
              </ul>
            </div>

            <div className="footer-column">
              <h4>Connect</h4>
              <ul>
                <li><a href="mailto:hello@6cs.com">Email</a></li>
                <li><a href="#contact">WhatsApp</a></li>
                <li><a href="#contact">Social Media</a></li>
              </ul>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} 6 C's. All rights reserved.</p>
          <p className="footer-6cs">
            Built on Creation, Curation, Connection, Conversion, Consistency, and Customer-Centricity
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

